howspace.sharedGroups = (() => {
    'use strict';

    const apiUrl = () => real.baseUri + '/api/sharedgroups';

    // Connecting and disconnecting queue a sync, whose own messages refresh the page when the people have moved. What
    // is refreshed here is what has changed already: the connection, so the chips and the count on the banner.
    const finish = (modal, message) => {
        howspace.components.modal.close(modal);

        const usersPage = howspace.manager?.users;
        if (usersPage?.afterSharedGroupChange) {
            usersPage.afterSharedGroupChange(message);
        } else {
            real.notification.show(message, 'success');
        }
    };

    // The button is a disclosure the collapse component runs, through aria-controls: it opens, closes and keeps
    // aria-expanded. This only fills the preview the first time it opens. Toggling it here as well made the two fight.
    const loadPreview = (item, groupId) => {
        const preview = item.find('.shared-group-member-preview');
        if (preview.data('loaded')) {
            return;
        }
        preview.data('loaded', true);

        real.ajax.html(real.baseUri + '/shared-groups/' + groupId + '/members-preview', {
            success: html => {
                // A member with a profile picture arrives as a picture component, which only loads once it is initialised.
                // Without this the placeholder spins forever while the initials avatars beside it render fine.
                preview.html(html);
                howspace.components.init(preview);
            },
            error: () => {
                preview.removeData('loaded');
            },
        });
    };

    const initConnectModal = modal => {
        modal = $(modal);

        modal.on('click', '.preview-shared-group-btn', e => {
            const button = $(e.currentTarget);
            loadPreview(button.closest('.shared-group-connect-item'), button.data('shared-group-id'));

            // The collapse component has flipped aria-expanded by now, its handler sits on the button itself. Two
            // literal calls, the translation build only picks up keys it can read.
            button.text(button.attr('aria-expanded') === 'true'
                ? howspace.translate('workspacesettings_users_shared_group_preview_hide')
                : howspace.translate('workspacesettings_users_shared_group_preview'));
        });

        modal.on('click', '.connect-shared-group-btn', e => {
            const button = $(e.currentTarget);
            real.button.loading(button);

            real.ajax.json(apiUrl(), {
                type: 'POST',
                data: JSON.stringify({shared_group_id: button.data('shared-group-id')}),
                success: () => {
                    finish(modal, howspace.translate('workspacesettings_users_shared_group_connected_syncing'));
                },
                error: () => {
                    real.button.reset(button);
                },
            });
        });

        // Disconnecting takes the people the group placed here out of the workspace, so it is asked first. The
        // question is loaded into the group's own card rather than opened as a modal: this one is already open, and
        // showing another closes it, which would leave whoever cancels with nothing in front of them.
        modal.on('click', '.disconnect-shared-group-btn', e => {
            const button = $(e.currentTarget);
            const item = button.closest('.shared-group-connect-item');
            const question = item.find('.shared-group-disconnect-confirm');

            if (question.children().length > 0) {
                question.removeClass('d-none');
                return;
            }

            real.button.loading(button);

            real.ajax.html(real.baseUri + '/shared-groups/' + button.data('shared-group-id') + '/disconnect-confirm', {
                success: html => {
                    real.button.reset(button);
                    question.html(html).removeClass('d-none');
                    howspace.components.init(question);
                },
                error: () => {
                    real.button.reset(button);
                },
            });
        });

        modal.on('click', '.cancel-disconnect-btn', e => {
            $(e.currentTarget).closest('.shared-group-disconnect-confirm').addClass('d-none');
        });

        modal.on('click', '.confirm-disconnect-btn', e => {
            const button = $(e.currentTarget);
            real.button.loading(button);

            real.ajax.json(real.baseUri + '/api/sharedgroup/' + button.data('shared-group-id'), {
                type: 'DELETE',
                success: () => {
                    finish(modal, howspace.translate('workspacesettings_users_shared_group_disconnected_syncing'));
                },
                error: () => {
                    real.button.reset(button);
                },
            });
        });
    };

    return {
        initConnectModal: initConnectModal,
    };
})();
